import "./SignUpThankYouOrdering.css";

export const SignUpThankYouOrdering = () => {
  return (
    <div className="thankYouMain" >
      <div className="thankYouContent" >
        <div className="thankYouLogo" >
           <img alt="Drops" className="landingBarImg" src="/images/landing/Illustrations/Various_Illustrations/DROPS_LOGO_10_21.svg" />
        </div>
        <div className="thankYouTitle">
          <h1>Your information has been saved securely</h1>
        </div>
      </div>
    </div>
  );
}

